var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgVitriol = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 81 87",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43.5 4 4 43.5 43.5 83M68.538 66.403 33.962 51.097M68.5 22 34 37.5M76.16 43.64l-23.82.22",
  stroke: "#59A509",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgVitriol;